module.exports = __webpack_public_path__ + "img/pan.b9dbbf42.jpg";